import CreateSlider from "../../components/CreateSlider";
function CreateSliderPage() {
  return (
    <div>
      <CreateSlider />
    </div>
  );
}

export default CreateSliderPage;
